import { render } from "./cms.vue?vue&type=template&id=a37d6176"
import script from "./cms.vue?vue&type=script&lang=js"
export * from "./cms.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__